import { Component } from '@angular/core';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RenderedOutputSummary, SituViewWebApiClient } from 'situview-webapi-client';

@Component({
  selector: 'interactive-theme-editor',
  templateUrl: './interactive-theme-editor.component.html',
  styleUrls: ['./interactive-theme-editor.component.scss']
})

export class InteractiveThemeEditor {
  selectedRenderedOutput?: RenderedOutputSummary = undefined;

  /* loading */
  private _loading = false;
  get loading(): boolean { return this._loading; }
  set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private snackBar: MatSnackBar,
    private situViewClient: SituViewWebApiClient,
    private breadcrumbService: BreadcrumbService,
  ) {

    if (!window.opener || window.opener.closed || window.opener.location.origin !== window.location.origin) {
      // This window is designed to work with a parent window
      // Close it if there is no parent window
      window.close();
    }
  }

  onSelectedRenderedOutput (renderedOutput: RenderedOutputSummary) {
    //console.log(renderedOutput);
    this.selectedRenderedOutput = renderedOutput;
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }

}
